/**
 * @generated SignedSource<<0e105d4a3fb7350d5e778582e84995e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UrlMappingDestinationModeType = "STATIC" | "TEMPLATE" | "%future added value";
export type UrlMappingMatchType = "EXACT" | "PREFIX" | "REGEX" | "HOST_PATH" | "TRANSFORM" | "%future added value";
export type UrlMappingEditFormContainer_Query$variables = {
  urlMappingId: string;
};
export type UrlMappingEditFormContainer_QueryVariables = UrlMappingEditFormContainer_Query$variables;
export type UrlMappingEditFormContainer_Query$data = {
  readonly node: {
    readonly id?: string;
    readonly name?: string | null;
    readonly active?: boolean;
    readonly matchType?: UrlMappingMatchType;
    readonly priority?: number;
    readonly sourceUrl?: string | null;
    readonly sourceHost?: string | null;
    readonly sourcePath?: string | null;
    readonly regexPattern?: string | null;
    readonly destinationUrl?: string;
    readonly destinationMode?: UrlMappingDestinationModeType;
    readonly conditions?: any;
    readonly startsAt?: string | null;
    readonly endsAt?: string | null;
  } | null;
};
export type UrlMappingEditFormContainer_QueryResponse = UrlMappingEditFormContainer_Query$data;
export type UrlMappingEditFormContainer_Query = {
  variables: UrlMappingEditFormContainer_QueryVariables;
  response: UrlMappingEditFormContainer_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "urlMappingId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "urlMappingId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "matchType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceHost",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourcePath",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regexPattern",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "destinationUrl",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "destinationMode",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conditions",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startsAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endsAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UrlMappingEditFormContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "type": "UrlMapping",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UrlMappingEditFormContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "type": "UrlMapping",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a7ab52a179dc97a67a7dcfcbb08d4d0c",
    "id": null,
    "metadata": {},
    "name": "UrlMappingEditFormContainer_Query",
    "operationKind": "query",
    "text": "query UrlMappingEditFormContainer_Query(\n  $urlMappingId: ID!\n) {\n  node(id: $urlMappingId) {\n    __typename\n    ... on UrlMapping {\n      id\n      name\n      active\n      matchType\n      priority\n      sourceUrl\n      sourceHost\n      sourcePath\n      regexPattern\n      destinationUrl\n      destinationMode\n      conditions\n      startsAt\n      endsAt\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a774942272e890269299c91322d83736";

export default node;
